const requiresExternalData = ["Cardiac"]
export default requiresExternalData


// WEBPACK FOOTER //
// ./src/texts/requiresExternalData.js